// removed by extract-text-webpack-plugin
module.exports = {"form_wrapper":"_10Ozz","form_name":"_2E5hV","form_select":"_1CSI9","form_select_dropdown":"_3BUcF","form_input":"_1CKYh","form_btn_wrapper":"tkYei","form_collapse":"_9qe0V","button":"_2I6sk","btn_primary":"_29dpE _2I6sk _29dpE _2I6sk","btn_secondary":"_2lB9f _2I6sk","btn_warning":"_2nW_a _2lB9f _2I6sk _2nW_a _2lB9f _2I6sk","root":"_3_rGW","input_wrapper":"_19apD _10Ozz","input_name":"_2kprM _2E5hV","text_input":"V1afN _1CKYh","button_wrapper":"im1P7 tkYei"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/templates/EditTemplate.css
// module id = 919
// module chunks = 0